import { ReactNode } from 'react';
import { NsInput } from 'components/common/ns-input/NsInput';
import { NsInputter } from 'components/common/ns-inputter/NsInputter';
import { useMaskPII } from 'hooks/useMaskPII';
import NsInputterEvent from 'components/common/ns-inputter/NsInputterEvent';
type Option = {
  label: string | ReactNode;
  value: string;
};

type NsCheckboxInputProps = {
  heading?: string;
  options: Option[];
  validation?: string[];
  value?: string | boolean;
  name?: string;
  onChange?: (event: NsInputterEvent) => void;
  testId?: string;
};

export const NsCheckboxInput = ({
  options,
  value,
  name,
  onChange,
  testId,
  validation,
  heading
}: NsCheckboxInputProps) => {
  const { mask } = useMaskPII();
  return (
    <NsInputter
      heading={heading}
      name={name}
      validation={validation}
      onChange={onChange}
      value={value}
    >
      {options.map(({ value, label }) => {
        return (
          <NsInput
            type="checkbox"
            key={value}
            id={value}
            name={name}
            value={value}
            label={label}
            testId={testId}
            inputAttributes={mask}
          />
        );
      })}
    </NsInputter>
  );
};
